'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_signing_SigningApi$$anon$3(outer) {
  this.bWd = null;
  this.bWb = null;
  this.bWc = false;
  this.bW9 = null;
  this.bWa = false;
  this.bWe = false;
  this.bWf = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bWd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_signing_SigningApi$$anon$3 as $c_Lpresto_pages_signing_SigningApi$$anon$3 };
$p = $c_Lpresto_pages_signing_SigningApi$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_signing_SigningApi$$anon$3;
/** @constructor */
function $h_Lpresto_pages_signing_SigningApi$$anon$3() {
}
export { $h_Lpresto_pages_signing_SigningApi$$anon$3 as $h_Lpresto_pages_signing_SigningApi$$anon$3 };
$h_Lpresto_pages_signing_SigningApi$$anon$3.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bWd;
});
$p.t = (function() {
  if ((!this.bWc)) {
    this.bWb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("reason", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bWc = true;
  }
  return this.bWb;
});
$p.ad = (function() {
  if ((!this.bWa)) {
    this.bW9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bWa = true;
  }
  return this.bW9;
});
$p.v = (function() {
  if ((!this.bWf)) {
    this.bWe = false;
    this.bWf = true;
  }
  return this.bWe;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_signing_SigningApi$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_signing_SigningApi$$anon$3, "presto.pages.signing.SigningApi$$anon$3", ({
  XB: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_signing_SigningApi$$anon$3 as $d_Lpresto_pages_signing_SigningApi$$anon$3 };
//# sourceMappingURL=presto.pages.signing.-Signing-Api$$anon$3.js.map
